"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExchangeForm = void 0;
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var customFetch_1 = require("../helpers/customFetch");
var react_router_dom_1 = require("react-router-dom");
var formatPrice_1 = require("../helpers/formatPrice");
var paymentSlice_1 = require("../redux/slice/paymentSlice");
var getPayment_1 = require("../helpers/car/getPayment");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../redux/selectors");
var sliderField = {
    steps: {
        credit_terms: [2, 6, 12, 24, 36, 48, 60, 72, 84, 96],
        initial_contribution: [0, 10, 20, 30, 40, 50, 60, 70, 80],
    },
    endpoints: {
        credit_terms: [2, 6, 12, 24, 36, 48, 60, 72, 84, 96],
        initial_contribution: [0, 10, 20, 30, 40, 50, 60, 70, 80],
    },
};
var useExchangeForm = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var modalCreditState = (0, react_redux_1.useSelector)(selectors_1.modalSelector).credit.modalState;
    var carPrice = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect.price || 0;
    var selectCarId = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect.id;
    var _a = (0, react_hook_form_1.useForm)({
        mode: 'onSubmit',
        defaultValues: {
            trade_in_credit: true,
            agree: true,
            initial_contribution: 0,
            credit_term: 0,
        },
        resolver: function (values) {
            var errorsResolver = {};
            if (!values.name) {
                errorsResolver.name = { type: 'required', message: 'Обязательное поле' };
            }
            if (!values.phone) {
                errorsResolver.phone = { type: 'required', message: 'Обязательное поле' };
            }
            if (!values.customer_car) {
                errorsResolver.customer_car = { type: 'required', message: 'Укажите ваш автомобиль' };
            }
            if (!modalCreditState && !values.car_id) {
                errorsResolver.car_id = { type: 'required', message: 'Выберите автомобиль' };
            }
            return {
                values: values,
                errors: errorsResolver,
            };
        },
    }), register = _a.register, errors = _a.formState.errors, handleSubmit = _a.handleSubmit, watch = _a.watch, setValue = _a.setValue, getValues = _a.getValues, reset = _a.reset;
    var _b = react_1.default.useState('0'), payment = _b[0], setPayment = _b[1];
    var inCreditField = watch('trade_in_credit', true);
    react_1.default.useEffect(function () {
        var initialContribution = sliderField.steps.initial_contribution[getValues('initial_contribution')];
        var creditTerm = sliderField.steps.credit_terms[getValues('credit_term')];
        dispatch((0, paymentSlice_1.setPaymentValue)({ initialContribution: initialContribution, creditTerm: creditTerm }));
        setPayment((0, formatPrice_1.formatPrice)((0, getPayment_1.getPayment)(carPrice, initialContribution, creditTerm, 4.9)));
    }, [watch(['initial_contribution', 'credit_term']), carPrice, dispatch, getValues, sliderField.steps]);
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var dataQuery, successInformation, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!data.agree) {
                        console.log('Agreement not checked');
                        return [2 /*return*/];
                    }
                    dataQuery = {
                        exchange: {
                            car_id: selectCarId,
                            credit_term: data.trade_in_credit ? sliderField.steps.credit_terms[data.credit_term] : 0,
                            customer_car: data.customer_car,
                            initial_contribution: data.trade_in_credit
                                ? (sliderField.steps.initial_contribution[data.initial_contribution] / 100) * carPrice
                                : 0,
                            name: data.name,
                            phone: data.phone,
                        },
                    };
                    console.log('Sending request:', JSON.stringify(dataQuery));
                    return [4 /*yield*/, (0, customFetch_1.customFetch)({
                            url: 'exchanges',
                            data: JSON.stringify(dataQuery),
                            method: 'POST',
                        })];
                case 1:
                    _a.sent();
                    successInformation = {
                        user_name: data.name,
                        select_car_id: data.car_id,
                        from: 'Трейд-ин предварительно одобрен',
                    };
                    navigate('/success', { state: successInformation, replace: true });
                    reset();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Submit error:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    react_1.default.useEffect(function () {
        if (modalCreditState) {
            reset();
        }
    }, [modalCreditState, reset]);
    return {
        sliderField: sliderField,
        handleSubmit: handleSubmit,
        onSubmit: onSubmit,
        register: register,
        errors: errors,
        inCreditField: inCreditField,
        setValue: setValue,
        payment: payment,
    };
};
exports.useExchangeForm = useExchangeForm;
